export default "__VITE_ASSET__DVreHzOv__"